import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../../http";

interface SecureLlmLimitResponse {
  limit: number;
  usage: number;
}

async function getSecureLlmLimit() {
  return await api.governance.get<SecureLlmLimitResponse>("secure_llm-limit");
}

export const secureLlmLimitQueryOptions = queryOptions({
  queryKey: ["secure-llm", "limit"],
  async queryFn() {
    const res = await getSecureLlmLimit();
    const data = await res.json();
    return data;
  },
});

export function useSecureLlmLimit() {
  return useQuery(secureLlmLimitQueryOptions);
}
